import {CourseBase} from "course/CourseBase";
import {SequenceDataMap} from "course/SequenceDataMap";
import {CourseEvents} from "course/CourseEvents";
import {LocalDataLoader} from "localstorage/LocalDataLoader";
import {Assert} from "common/Assert";
import {Event} from "common/Event";

export function LocalStorageCourse(userId, options ){

    Assert.checkArgument( typeof(userId) === "string" );

    const localDataLoader = new LocalDataLoader( userId ),
          courseBase = new CourseBase( options ? options.nMasteryScore : null ),
          sequenceDataMap = new SequenceDataMap();

    initEventListener();

    function initEventListener() {
        Event.on( document, CourseEvents.COURSE_REFRESH, refreshStatus );
        Event.on( document, CourseEvents.SEQUENCE_TERMINATED, () => {
            courseBase.setSequenceClosed();
            refreshStatus();
        });
    }

    function refreshStatus(){
        localDataLoader.refreshDataBuffer();
    }

    // revealing public api
    return {

        // config api

        getClassName: () => "CookieCourse",

        getProfileController: () => localDataLoader,
        setUsername: localDataLoader.setUsername,
        getUsername: localDataLoader.getUsername,

        /**
         * Gets the storage system for the course.
         *
         * @returns {String} "local_maschine"
         */
        getStorageSystem : () => "local_maschine",

        /**
         * Gets the storage method for the course.
         *
         * @returns {String} "cookies"
         */
        getStorageMethod: localDataLoader.getStorageMethod,

        getCourseMasteryScore: courseBase.getCourseMasteryScore,

        /**
         * It is allowed to start multiple cookie SCOs at the same time.
         *
         * @returns {boolean} true
         */
        isMultiScoLaunchAllowed: () => true,

        useScoLaunchParams: () => false,

        initScoreIDs: sequenceDataMap.initScoreIDs,

        prepareSequenceLaunch: courseBase.setSequenceOpened,
        isSequenceConnected : () => false,
        initSequenceData: sequenceDataMap.initSequenceData,
        getSequenceData: sequenceDataMap.getSequenceData,
        setSequenceData: sequenceDataMap.setSequenceData,
        getSequenceDataMap: sequenceDataMap.getSequenceDataMap,
        clearSequenceDataMap: sequenceDataMap.clearSequenceDataMap,

        /**
         * Does nothing for a cookie course
         */
        terminate: () => {},

        /**
         * @deprecated
         *
         * @return {Boolean} true
         */
        handleBrowserOnTerminate: () => true,


        //core api

        onSequenceTerminate: courseBase.setSequenceClosed,
        getSequenceInfos: sequenceDataMap.getSequenceInfos,
        getResultMap: sequenceDataMap.getResultMap,
        getScoreIDs: sequenceDataMap.getScoreIDs,
        refreshStatus : refreshStatus
    };
}
